var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserAccessNv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 33C27 30.7909 28.7909 29 31 29H39C41.2091 29 43 30.7909 43 33V39C43 41.2091 41.2091 43 39 43H31C28.7909 43 27 41.2091 27 39V33ZM31 31C29.8954 31 29 31.8954 29 33V39C29 40.1046 29.8954 41 31 41H39C40.1046 41 41 40.1046 41 39V33C41 31.8954 40.1046 31 39 31H31Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 26C31 24.3431 32.3431 23 34 23H36C37.6569 23 39 24.3431 39 26V30H37V26C37 25.4477 36.5523 25 36 25H34C33.4477 25 33 25.4477 33 26V30H31V26Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 5C15.6863 5 13 7.68629 13 11C13 14.3137 15.6863 17 19 17C22.3137 17 25 14.3137 25 11C25 7.68629 22.3137 5 19 5ZM11 11C11 6.58172 14.5817 3 19 3C23.4183 3 27 6.58172 27 11C27 15.4183 23.4183 19 19 19C14.5817 19 11 15.4183 11 11Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 34C5 26.8203 10.8203 21 18 21H20C22.7308 21 25.2677 21.8431 27.3608 23.2833C27.8158 23.5963 27.9308 24.219 27.6178 24.6739C27.3047 25.1289 26.6821 25.244 26.2271 24.9309C24.4569 23.7129 22.3132 23 20 23H18C11.9249 23 7 27.9249 7 34V36C7 36.5523 7.44772 37 8 37H22C22.5523 37 23 37.4477 23 38C23 38.5523 22.5523 39 22 39H8C6.34315 39 5 37.6569 5 36V34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAccessNv);
export default __webpack_public_path__ + "static/media/UserAccess_nv.f5399a6fe500c411518a804b524a73b1.svg";
export { ForwardRef as ReactComponent };